<div class="header-container" *ngIf="showHeader()">
  <app-header class="avatar-disabled" text="{{ title | translate}}">
    <ion-icon name="notifications" class="disabled notifications-bell"></ion-icon>
    <ion-icon name="icon-search" class="disabled search"> </ion-icon>
  </app-header>
</div>

<main class="content-container">
  <div class="grid">
    <div class="row">
      <div class="col no-padding" size="12">
        <div class="image-container">
          <img class="disconnected" src="assets/imgs/offline/offline.svg" alt="Offline image" />
        </div>
      </div>
    </div>
    <div class="row">
      <img class="warning" src="assets/imgs/icons/danger.svg" alt="Warning icon" />
      <h1>{{ 'ERROR_MESSAGES.OPS' | translate }}</h1>
    </div>
    <div class="row">
      <p>{{ 'ERROR_MESSAGES.CONNECTION_LOST' | translate }}</p>
    </div>
    <div class="row">
      <p>{{ 'ERROR_MESSAGES.CHECK_CONNECTION' | translate }}</p>
    </div>
    <div class="row">
      <button class="c-button primary" (click)="retry()">{{ 'ERROR_MESSAGES.RETRY' | translate }}</button>
    </div>
  </div>
</main>
